export default class ModalOptions {
  constructor(
    public title: string,
    public message: string,
    public icon: string = 'option-selected',
    public hideCancelButton: boolean = false,
    public confirmText: string = '',
    public cancelText: string = '',
    public confirmEvent: string = 'onConfirm',
    public buttonDisabled: boolean = false,
    public componentToRender?: string,
    public showButtons?: boolean,
    public customSize?: boolean,
    public noBackground?: boolean,
    public centralizeContent?: boolean,
    public mobileFullScreen?: boolean,
    public step?: any,
    public disableModalBehaviourMobile?: boolean,
    public mobilePositionBottom?: boolean,
    public fullWidth?: boolean,
    public removeBackground?: boolean
  ) {}
}

interface ModalOptionsProps {
  title?: string;
  message?: string;
  icon: string;
  hideCancelButton: boolean;
  confirmText?: string;
  cancelText?: string;
  confirmEvent?: string;
  buttonDisabled?: boolean;
  componentToRender?: string;
  showButtons?: boolean;
  customSize?: boolean;
  noBackground?: boolean;
  centralizeContent?: boolean;
  mobileFullScreen?: boolean;
  step?: any;
  disableModalBehaviourMobile?: boolean;
  mobilePositionBottom?: boolean;
  fullWidth?: boolean;
  removeBackground?: boolean;
}
export class ModalOptionsV2 {
  title?: string = '';
  message?: string = '';
  icon: string = 'option-selected';
  hideCancelButton: boolean = false;
  confirmText?: string = '';
  cancelText?: string = '';
  confirmEvent?: string = 'onConfirm';
  buttonDisabled?: boolean = false;
  componentToRender?: string;
  showButtons?: boolean = false;
  customSize?: boolean = true;
  noBackground?: boolean = true;
  centralizeContent?: boolean = true;
  mobileFullScreen?: boolean = true;
  step?: any;
  disableModalBehaviourMobile?: boolean;
  mobilePositionBottom?: boolean;
  fullWidth?: boolean;
  removeBackground?: boolean;

  constructor(options: ModalOptionsProps) {
    Object.assign(this, options);
  }
}
